export default "__VITE_ASSET__CyiM7xx1__"